var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.10192 9.40008C6.20192 9.50008 6.32858 9.54674 6.45525 9.54674C6.58192 9.54674 6.70858 9.50008 6.80858 9.40008L10.8553 5.35341C11.0486 5.16008 11.0486 4.84008 10.8553 4.64674L6.80858 0.600078C6.61525 0.406745 6.29525 0.406745 6.10192 0.600078C5.90858 0.793411 5.90858 1.11341 6.10192 1.30674L9.29517 4.5H1.24503C1.02139 4.5 0.835938 4.72667 0.835938 5C0.835938 5.27333 1.02139 5.5 1.24503 5.5H9.29533L6.10192 8.69341C5.90858 8.88674 5.90858 9.20674 6.10192 9.40008Z",
    fill: "#24272A",
    fillOpacity: 0.36
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightGrey);
export default __webpack_public_path__ + "static/media/arrow-right-grey.62b0f1841f30f3c68ab7a052a227d9da.svg";
export { ForwardRef as ReactComponent };